import { render, staticRenderFns } from "./TradeReportLayout.vue?vue&type=template&id=587189b5&scoped=true&"
import script from "./TradeReportLayout.vue?vue&type=script&lang=js&"
export * from "./TradeReportLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587189b5",
  null
  
)

export default component.exports